import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";
import { Observable, of } from "rxjs";
import { CachingService } from "../services/caching.service";
import { tap } from "rxjs/operators";
import { API_NAME } from "src/app/core/models/MODULES";
import { Caching } from "../models/masterTableModels";

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
  constructor(private cache: CachingService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let api: string = request.context.get(API_NAME)!;

    if (request.method !== "GET") return next.handle(request);

    const cachedResponse: HttpResponse<any> = this.cache.get(api)!;

    if (cachedResponse && (cachedResponse as unknown as Caching<any>).cacheable)
      return of(cachedResponse);

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && api) {
          this.cache.put(api, event);
        }
      })
    );
  }
}
